import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../i18n";

export function LoadingPanel({ label, minHeight = 260 }) {
  const { t } = useTranslation();
  return (
    <Box sx={{ minHeight, display: "grid", placeItems: "center" }}>
      <Box sx={{ textAlign: "center" }}>
        <CircularProgress size={34} />
        <Typography color="text.secondary" sx={{ mt: 1.5 }}>
          {label || t("common.loading")}
        </Typography>
      </Box>
    </Box>
  );
}

export function ErrorPanel({ message, onRetry }) {
  const { t } = useTranslation();
  if (!message) return null;
  return (
    <Alert
      severity="error"
      sx={{ mb: 3, borderRadius: 3 }}
      action={
        onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry}>
            {t("common.retry")}
          </Button>
        ) : null
      }
    >
      {message}
    </Alert>
  );
}

export function EmptyPanel({ icon = "📭", title, description, action }) {
  return (
    <Box
      sx={{
        py: { xs: 5, md: 7 },
        px: 3,
        textAlign: "center",
        bgcolor: "white",
        border: "1px dashed #cbd5e1",
        borderRadius: 4,
      }}
    >
      <Typography sx={{ fontSize: 44, mb: 1 }}>{icon}</Typography>
      <Typography variant="h6" fontWeight={900}>
        {title}
      </Typography>
      <Typography color="text.secondary" sx={{ mt: 0.75, mb: action ? 2.5 : 0 }}>
        {description}
      </Typography>
      {action}
    </Box>
  );
}
